module.exports = __webpack_public_path__ + "static/media/course_04.4387a0d0.jpg";